import clsx from "clsx";

interface PropsWithChildren {
  children: React.ReactNode;
  className?: string;
}

export const Table = ({
  children,
  className,
  tableLayout = "fixed",
}: { tableLayout?: "auto" | "fixed" } & PropsWithChildren) => (
  <table
    className={clsx(
      `table-${tableLayout}`,
      `outline outline-1 outline-gray-1 rounded-lg border-collapse table-striped
[&_tr]:h-10
[&_td]:pl-4 [&_td]:pr-2 [&_th]:pl-4 [&_th]:pr-2
text-sm`,
      className,
    )}
  >
    {children}
  </table>
);
